import { ref } from 'vue'

export default function () {
  const localScrollTarget = ref(null)
  let scrollFn

  function changeScrollEvent(scrollTarget, handler) {
    const eventListenerMethod = handler
      ? 'addEventListener'
      : 'removeEventListener'
    const eventHandler = handler || scrollFn

    window[eventListenerMethod]('scroll', eventHandler, { passive: true })

    scrollFn = handler
  }

  function unconfigureScrollTarget() {
    if (localScrollTarget.value !== null) {
      changeScrollEvent(localScrollTarget.value)
      localScrollTarget.value = null
    }
  }

  return {
    localScrollTarget,
    unconfigureScrollTarget,
    changeScrollEvent
  }
}
